import React from "react";
import { Stage, Layer, Rect, Group } from "react-konva";
import Konva from "konva";
import { useEffect } from "react";
import { EPDGroupGraphic, GraphicLayerData } from "api-client";
import { BPEStore } from "../ProductEditorStore.ts";

export interface PatternDictionary {
  [id: string]: HTMLImageElement;
}
const GraphicObject = ({
  info,
  size,
  patternImages,
}: {
  info?: EPDGroupGraphic | null;
  size: number;
  patternImages: PatternDictionary;
}) => {
  const stageRef = React.useRef<Konva.Stage>(null);

  function dataURLtoFile(dataURL: string, filename: string): File {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  function generateImageFromGraphic() {
    const uri = stageRef.current?.toDataURL({ pixelRatio: 2 });
    if (uri) {
      const timestamp = new Date().toLocaleDateString("de-DE");
      const file = dataURLtoFile(uri, `Produktgrafik_${timestamp}.png`);
      BPEStore.setDiagramsToUpload([file]);
    }
  }

  useEffect(() => {
    if (!stageRef.current) return;
    const timeout = setTimeout(() => {
      generateImageFromGraphic();
    }, 100);

    return () => clearTimeout(timeout);
  }, [patternImages, info?.layers, stageRef?.current]);

  const showLayerGraphic = (
    layers: GraphicLayerData[],
    layer: GraphicLayerData,
    index: number
  ) => {
    let accumulatedX = 0;
    for (let i = 0; i < index; i++) {
      accumulatedX += layers[i].percentage * size;
    }

    return (
      <Group key={index}>
        {layer.fill_color && (
          <Rect
            key={`fill_${layer.epd_id}`}
            width={layer.percentage * size}
            height={size}
            x={accumulatedX}
            fill={layer.fill_color}
            strokeWidth={1}
            stroke="darkgray"
          />
        )}
        {layer.fill_pattern && (
          <Rect
            key={`pattern_${layer.epd_id}`}
            width={layer.percentage * size}
            height={size}
            x={accumulatedX}
            fillPatternImage={patternImages[layer.fill_pattern]}
            strokeWidth={1}
            stroke="darkgray"
            fillPatternScaleX={0.5}
            fillPatternScaleY={0.5}
          />
        )}
      </Group>
    );
  };

  if (!patternImages || !info?.layers) return null;
  return (
    <div className="rounded-md overflow-hidden">
      <Stage width={size} height={size} ref={stageRef}>
        <Layer>
          <Group x={0} y={0}>
            {info.layers.map(
              (layer, index) =>
                info.layers && showLayerGraphic(info.layers ?? [], layer, index)
            )}
          </Group>
        </Layer>
      </Stage>
    </div>
  );
};

export default GraphicObject;
